import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { soloNumero } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { saveAularioAction } from '../AularioAction';

const FormAulario = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const aularioStore = Redux.useSelector((state) => state.aulario);

  const activo = aularioStore.activo;

  const initData = {
    nombre: '',
    numero: '',
    capacidad: '',
    isAbierto: true,
    isOperativo: true,
    desc: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    numero: false,
    capacidad: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }

    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveAularioAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
        },
        aularioStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            type="number"
            fullWidth
            size="small"
            id={CONST.capacidad.name}
            required
            label={CONST.capacidad.label}
            value={data.capacidad}
            onChange={(e) =>
              _handleSetDataField(
                CONST.capacidad.name,
                soloNumero(e.target.value),
              )
            }
            helperText={dataError.capacidad ? validMessage.required : null}
            error={dataError.capacidad}
            InputProps={{
              inputProps: { min: 1 },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.isOperativo}
                onChange={(e) =>
                  _handleSetDataField(CONST.isOperativo.name, e.target.checked)
                }
              />
            }
            label={CONST.isOperativo.quest}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.isAbierto}
                onChange={(e) =>
                  _handleSetDataField(CONST.isAbierto.name, e.target.checked)
                }
              />
            }
            label={CONST.isAbierto.quest}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            type="number"
            fullWidth
            size="small"
            id={CONST.numero.name}
            required
            label={CONST.numero.label}
            value={data.numero}
            onChange={(e) =>
              _handleSetDataField(CONST.numero.name, soloNumero(e.target.value))
            }
            helperText={dataError.numero ? validMessage.required : null}
            error={dataError.numero}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormAulario;
